import { useEffect } from 'react';
import seedrandom from 'seedrandom';

const LoadingAnalyzing = ({ onNext, poolURL, zipCode }) => {
    useEffect(() => {
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 100);
        setTimeout(() => {
            window.scrollTo(0, 0);
            setTimeout(() => {
                onNext(true, true);
            }, 500)
        }, 4500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const generateNeighbour = (zipCode, min, max) => {
        const rng = seedrandom(zipCode);
        const randomNumber = Math.floor(rng() * (max - min + 1)) + min;
        return randomNumber;
    }

    return (
        <>
            <div className="card-loading-analyzing">
                <h1 className="page-title">
                    This will take just a moment. Our AI is cross-referencing your pool details with real-time pricing data and our service routes for a precise quote.
                </h1>
                <p>
                    <span>{generateNeighbour(zipCode, 10, 60)} neighbors</span> in {zipCode} already use Cabana. Join them today!
                </p>
                <div className="half-border-image">
                    <img src={poolURL || "/images/analyzing-logo.svg"} alt="analyzing-logo" />
                </div>
            </div>
            <input type="hidden" id="progress_slide_1" data-width="90%" />
        </>
    )
}

export default LoadingAnalyzing